import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import HighlightText from '../components/HighlightText'
import FeaturesHeading from '../components/FeaturesHeading'

const MobileFeatures = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [features, setFeatures] = useState([])

    useEffect(() => {
        DataSource.getData('/api/getContent/mobile/features', response => {
            setFeatures(response.features)
            setIsLoaded(true)
        })
    }, [])

    const HeadingDesktop = <React.Fragment>Powered-up with loads<br />of <HighlightText height='16px'>on-point features</HighlightText></React.Fragment>
    const HeadingMobile = <span>Powered-up with loads of <HighlightText height='16px'>on-point features</HighlightText></span>

    return (
        <FeaturesHeading
            features={features}
            headingDesktop={HeadingDesktop}
            headingMobile={HeadingMobile}
            hasBgTop={false}
            hasBasicHeading
            isLoaded={isLoaded}
            noAnimation
        >
            <p className='mb-0'>Our super-value SIM-only plans include:</p>
        </FeaturesHeading>
    )
}

export default MobileFeatures



// WEBPACK FOOTER //
// ./resources/js/mobile/MobileFeatures.js